import { render } from "./Header-Short-New.vue?vue&type=template&id=d50baeae"
import script from "./Header-Short-New.vue?vue&type=script&lang=js"
export * from "./Header-Short-New.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__